import { render, staticRenderFns } from "./PrePage.vue?vue&type=template&id=6bc7a118&scoped=true&"
import script from "./PrePage.vue?vue&type=script&lang=js&"
export * from "./PrePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc7a118",
  null
  
)

export default component.exports